app.service("PermissionAPI", [
	"$http",
	"ENV",
	"Session",
	function ($http, ENV, Session) {
		function request(method, path, data) {
			return $http({
				method: method,
				url: ENV.API + path,
				headers: {
					Authorization: "Bearer " + Session.token,
				},
				data: data,
			});
		}

		var service = {
			// Every permission, with its group, paid features, default roles and whether it is locked.
			getCatalogue: function () {
				return request("GET", "/api/permissions");
			},

			// CatTrax admins only: refusals and would-be refusals over the last few days, by kind, with each
			// person counted. CatTrax staff and test practices are left out unless asked for.
			getRefusals: function (days, options) {
				options = options || {};
				return request("GET", "/api/permissions/refusals?days=" + days
					+ "&excludeAdmins=" + (options.includeAdmins ? "false" : "true")
					+ "&excludeTestPractices=" + (options.includeTestPractices ? "false" : "true"));
			},

			// CatTrax admins only: what every role can do at every practice.
			getRolesEverywhere: function () {
				return request("GET", "/api/permissions/roles");
			},
			saveRoleEverywhere: function (role, permissions) {
				return request("PUT", "/api/permissions/roles/" + role, { permissions: permissions });
			},

			// Practice managers: what every role can do at their practice.
			getPracticeRoles: function (practiceId) {
				return request("GET", "/api/practices/" + practiceId + "/permissions/roles");
			},
			savePracticeRole: function (practiceId, role, permissions) {
				return request("PUT", "/api/practices/" + practiceId + "/permissions/roles/" + role, {
					permissions: permissions,
				});
			},

			// Practice managers: one person's access and exception at their practice.
			getUserPermissions: function (practiceId, userId) {
				return request("GET", "/api/practices/" + practiceId + "/permissions/users/" + userId);
			},
			saveUserPermissions: function (practiceId, userId, permissions) {
				return request("PUT", "/api/practices/" + practiceId + "/permissions/users/" + userId, {
					permissions: permissions,
				});
			},

			getStaff: function (practiceId) {
				return request("GET", "/api/practices/" + practiceId + "/staff");
			},
			saveStaffRoles: function (practiceId, userId, roles) {
				return request("PUT", "/api/practices/" + practiceId + "/staff/" + userId + "/roles", { roles: roles });
			},

			// The server's explanation when a change is refused, e.g. a permission only CatTrax can change.
			errorMessage: function (response, fallback) {
				return (response && response.data && response.data.message) || fallback;
			},
		};

		return service;
	},
]);
